import React from 'react';
import additional from './companyInfo_color.svg'

const CompanyInfo_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default CompanyInfo_color;
